import React from 'react';
import { Backup } from '@mui/icons-material';
import { Box, Fab } from '@mui/material';
import { Colors } from '../../utils/theme';

export type ImageContainerMargins = {
  height: string;
  backupMarginTop: number;
};

interface IProps {
  editable: boolean;
  loading: boolean;
  dimensions: ImageContainerMargins;
  setImage: (value: React.SetStateAction<string | null | undefined>) => void;
}

const EmailBannerUploader: React.FunctionComponent<IProps> = ({
  editable,
  loading,
  dimensions,
  setImage
}: IProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event && event.target && event.target.files) {
      const file = event.target.files[0];
      processFile(file);
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (editable && event && event.dataTransfer.files) {
      const file = event.dataTransfer.files[0];
      processFile(file);
      event.dataTransfer.clearData();
    }
  };

  const processFile = (file: File) => {
    if (file) {
      const render = new FileReader();
      render.readAsDataURL(file);
      render.onload = (e) => {
        if (e && e.target) {
          setImage(e.target.result as string);
        }
      };
    }
  };

  const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <Box
      id="product-email-banner-body"
      sx={{
        textAlign: 'center',
        border: '1px solid #DFDFE0',
        borderRadius: '12px',
        marginTop: '12px',
        height: dimensions.height
      }}
      onDrop={(e) => handleDrop(e)}
      onDragOver={(e) => handleDragOver(e)}
      onDragEnter={(e) => handleDragEnter(e)}
      onDragLeave={(e) => handleDragLeave(e)}
    >
      <input
        accept="image/*"
        id="product-email-banner"
        type="file"
        onChange={handleChange}
        style={{ display: 'none' }}
        disabled={!editable || loading}
      />
      <label htmlFor="product-email-banner">
        <Fab
          component="span"
          style={{
            color: 'white',
            width: 84,
            height: 84,
            marginTop: dimensions.backupMarginTop,
            marginBottom: 17
          }}
          disabled={!editable || loading}
        >
          <Backup style={{ width: 50, height: 41 }} />
        </Fab>
        <span
          style={{
            textDecoration: 'underline',
            cursor: 'pointer',
            display: 'block',
            textAlign: 'center',
            color: editable ? Colors.skyBlue : Colors.gray
          }}
        >
          Upload Banner
        </span>
      </label>
    </Box>
  );
};

export default EmailBannerUploader;
